import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {

  private requestCount = 0;

  constructor(private spinner: NgxSpinnerService) {
  }

  // This interceptor keeps track of the number of ongoing HTTP requests.
  // It shows the spinner when the first request starts and hides it when all requests have completed.
  // A delay is added before showing the spinner to prevent flickering for quick requests.
  // Not required to add finalize in every service call and helps to centralize the spinner logic in one place.
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.requestCount++;

    if (this.requestCount === 1) {
      //Adding a small delay before showing the spinner to prevent flickering for quick requests
      setTimeout(() => {
        if (this.requestCount > 0) {
          this.spinner.show();
        }
      }, 150);
    }

    return next.handle(req).pipe(
      finalize(() => {
        this.requestCount--;

        if (this.requestCount === 0) {
          // All requests have completed, hide the spinner
          this.spinner.hide();
        }
      })
    );
  }
}
